import type { StreamAiCreditDenied } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import {
	isStoreAssistant,
	isStoreCreditDenial,
	isStoreHuman,
	type StoreChatItem,
	type StoreCreditDenial,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { getStoreMessageId } from './getStoreMessageId';

type ProcessCreditDenialOptions = {
	messages: StoreChatItem[];
	streamMessage: StreamAiCreditDenied;
	assistantMessageId: string;
	includeHistoryItem: boolean;
};

export type ProcessCreditDenialResult = {
	messages: StoreChatItem[];
	creditDenial: StoreCreditDenial;
	isDuplicate: boolean;
};

export const processCreditDenial = ({
	messages,
	streamMessage,
	assistantMessageId,
	includeHistoryItem,
}: ProcessCreditDenialOptions): ProcessCreditDenialResult => {
	const id =
		streamMessage.metadata?.request_id ??
		(streamMessage.sequence_id === undefined
			? assistantMessageId
			: String(streamMessage.sequence_id));
	const creditDenial: StoreCreditDenial = {
		type: 'CREDIT_DENIAL',
		id,
		denial: streamMessage.denial,
	};
	const messagesWithoutPendingAssistant = messages.filter(
		(message) =>
			!isStoreAssistant(message) ||
			getStoreMessageId(message) !== assistantMessageId ||
			message.content.message.message.content !== '',
	);
	let currentTurnStartIndex = 0;
	for (let index = messagesWithoutPendingAssistant.length - 1; index >= 0; index--) {
		if (isStoreHuman(messagesWithoutPendingAssistant[index])) {
			currentTurnStartIndex = index + 1;
			break;
		}
	}
	const isDuplicate = messagesWithoutPendingAssistant
		.slice(currentTurnStartIndex)
		.some(isStoreCreditDenial);

	return {
		messages:
			includeHistoryItem && !isDuplicate
				? [...messagesWithoutPendingAssistant, creditDenial]
				: messagesWithoutPendingAssistant,
		creditDenial,
		isDuplicate,
	};
};
